import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface PendingAction {
  toolName: string
  args: Record<string, unknown>
  description: string
}

interface ChatbotConfirmParams {
  conversationId: string
  actions: { toolName: string; args: Record<string, unknown> }[]
}

interface ChatbotConfirmResponse {
  response: string
  success: boolean
  pendingActions?: PendingAction[]
}

const confirmAction = async (params: ChatbotConfirmParams): Promise<ChatbotConfirmResponse> => {
  const { data } = await api.post<ChatbotConfirmResponse>('/ft_chatbot/confirm-action', params)
  return data
}

export const useFtChatbotConfirm = () => {
  return useMutation<ChatbotConfirmResponse, Error, ChatbotConfirmParams>({
    mutationFn: confirmAction,
  })
}
